/* quantity-input.js — <quantity-input> stepper around a number input. */
(function () {
  'use strict';
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      if (!this.input) return;
      this.buttons = this.querySelectorAll('button[data-qty-action]');
      this.buttons.forEach((b) => b.addEventListener('click', this.onButton.bind(this)));
      this.input.addEventListener('change', this.onChange.bind(this));
    }

    onButton(e) {
      e.preventDefault();
      const dir = e.currentTarget.getAttribute('data-qty-action');
      const step = parseFloat(this.input.step) || 1;
      const min = this.input.min !== '' ? parseFloat(this.input.min) : 1;
      const max = this.input.max !== '' ? parseFloat(this.input.max) : Infinity;
      let value = parseFloat(this.input.value) || min;
      value = dir === 'increase' ? value + step : value - step;
      value = Math.min(max, Math.max(min, value));
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onChange() {
      const min = this.input.min !== '' ? parseFloat(this.input.min) : 1;
      if ((parseFloat(this.input.value) || 0) < min) this.input.value = min;
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
})();
